import React from 'react';
import { Link } from 'react-router-dom';

// scss
import './FloorMap.scss';

type Props = {
  active: number, 
}

const FloorMap3: React.FC<Props> = (props) => {
  return (
    <div id="FloorMap3">
      <div className="wrapper">
        <div className="bg">
          <ul>
            <li className={props.active===0 ? 'area0 active' : 'area0'}><Link to={'/digital/fair2021/showroom/floor3/area01.html'} /></li>
            <li className={props.active===1 ? 'area1 active' : 'area1'}><Link to={'/digital/fair2021/showroom/floor3/area02.html'} /></li>
            <li className={props.active===2 ? 'area2 active' : 'area2'}><Link to={'/digital/fair2021/showroom/floor3/area03.html'} /></li>
            <li className={props.active===3 ? 'area3 active' : 'area3'}><Link to={'/digital/fair2021/showroom/floor3/area04.html'} /></li>
            <li className={props.active===4 ? 'area4 active' : 'area4'}><Link to={'/digital/fair2021/showroom/floor3/area05.html'} /></li>
            <li className={props.active===5 ? 'area5 active' : 'area5'}><Link to={'/digital/fair2021/showroom/floor3/area06.html'} /></li>
            <li className={props.active===6 ? 'area6 active' : 'area6'}><Link to={'/digital/fair2021/showroom/floor3/area07.html'} /></li>
            <li className={props.active===8 ? 'area7 active' : 'area7'}><Link to={'/digital/fair2021/showroom/floor3/area09.html'} /></li>
            <li className={props.active===7 ? 'area8 active' : 'area8'}><Link to={'/digital/fair2021/showroom/floor3/area08.html'} /></li>
            <li className={props.active===9 ? 'area9 active' : 'area9'}><Link to={'/digital/fair2021/showroom/floor3/area10.html'} /></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default FloorMap3;
